import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const searchRiders = (request: SearchRidersRequest) => {
  const url = `${apiConfiguration.apiUrl}/riders/search`;
  return axios.get<SearchRidersResponse>(url, { params: request });
};
